webpackJsonpUpdateBris([61],{

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'QuantityInput';
var CLS = 'quantityInput';
var WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/quantityInput.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


var QuantityInput = exports.QuantityInput = function () {
	function QuantityInput($el) {
		_classCallCheck(this, QuantityInput);

		// $el is the widget node return by the loadQuantityInput function
		this.$el = $el;
		this.removeZero = false;
	}

	_createClass(QuantityInput, [{
		key: 'init',
		value: function init() {
			this.checkRemoveZero();
			this.setQuantityInput();
		}
	}, {
		key: 'checkRemoveZero',
		value: function checkRemoveZero() {
			var removeZero = $(this.$el).attr('remove-zero');
			this.removeZero = typeof removeZero !== 'undefined' && removeZero !== false;
		}
	}, {
		key: 'setQuantityInput',
		value: function setQuantityInput() {
			// Add Some logic here
			var This = this;
			var $wg = $(this.$el);
			var $btns = $wg.find('.btn-up, .btn-down');
			var $btnsUp = $wg.find('.btn-up');
			var $btnsDown = $wg.find('.btn-down');

			var $input = $wg.find('input');
			var maxInput = parseInt($input.attr('max'));
			var minInput = parseInt($input.attr('min'));
			var stepInput = parseInt($input.attr('step'));
			var oldValue = $input.val();
			var timeOut = null;

			if (maxInput < 0) {
				$input.removeAttr('max');
				maxInput = null;
			}

			function getValidValue(value) {
				var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : minInput;
				var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : maxInput;

				var val = parseInt(value);
				if (isNaN(val)) {
					return minInput;
				}
				if (val < min) {
					val = min;
				}
				if (max && val > max) {
					val = max;
				}
				return val;
			}

			function calcValue(value) {
				var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : maxInput;
				var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : minInput;
				var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : stepInput;
				var status = arguments[4];

				var val = parseInt(value);
				if (isNaN(val) || val + stepInput < minInput) {
					return minInput;
				}

				if (status == 'increase' && $btnsUp.hasClass('disabled') == true) {
					return val;
				} else if (status == 'increase' && $btnsUp.hasClass('disabled') == false) {
					if (maxInput) {
						val = val < maxInput - stepInput ? val + stepInput : maxInput;
					} else {
						val = val + stepInput;
					}
				} else {
					val = val > minInput + stepInput ? val - stepInput : minInput;
				}
				return val;
			}

			$input.on('keypress', function (e) {
				var code = e.keyCode || e.which;
				// prevent (. , + - e)
				if (code == 46 || code == 44 || code == 43 || code == 45 || code == 101) {
					e.preventDefault();
					return false;
				}
			});

			$input.on('keyup', function (e) {
				This.checkRemoveZero();
				var code = e.keyCode || e.which;
				if (code == 40) {
					$(this).val(calcValue(oldValue, maxInput, minInput, stepInput, 'decrease'));
					oldValue = $input.val();
					$(this).trigger('change');
				}
				if (code == 38) {
					$(this).val(calcValue(oldValue, maxInput, minInput, stepInput, 'increase'));
					oldValue = $input.val();
					$(this).trigger('change');
				}
				oldValue = $input.val();
				if (oldValue <= maxInput) {
					$btnsUp.removeClass('disabled');
				}
				if (oldValue >= minInput) {
					$btnsDown.removeClass('disabled');
				}
			});

			$input.on('blur', function () {
				This.checkRemoveZero();
				timeOut = setTimeout(function () {
					$(this).val(getValidValue(parseInt($(this).val()), minInput, maxInput));
					if (getValidValue(parseInt($(this).val())) <= maxInput) {
						$btnsUp.removeClass('disabled');
					}
					if (getValidValue(parseInt($(this).val())) >= minInput) {
						$btnsDown.removeClass('disabled');
					}
					$(this).trigger('change');
				}.bind(this), 200);
			});

			$btns.on('click', function (e) {
				This.checkRemoveZero();
				clearTimeout(timeOut);
				if ($(this).hasClass('disabled')) {
					e.stopPropagation();
					return;
				};

				var currentVal = $input.val();
				if ($(this).hasClass('btn-up')) {
					$input.val(calcValue(currentVal, maxInput, minInput, stepInput, 'increase'));
					var incr = $input.val();
					if (parseInt(incr) === maxInput) {
						$(this).addClass('disabled');
					}
					if ($btnsDown.hasClass('disabled')) {
						$btnsDown.removeClass('disabled');
					}
					if ($btnsDown.hasClass('zero')) {
						$btnsDown.removeClass('zero');
					}
				} else {
					var decr = $input.val();
					if (parseInt(decr) === 1 && This.removeZero) {
						$(this).addClass('zero');
					}

					$input.val(calcValue(currentVal, maxInput, minInput, stepInput, 'decrease'));
					decr = $input.val();

					if (parseInt(decr) === minInput && !This.removeZero) {
						$(this).addClass('disabled');
					}
					if ($btnsUp.hasClass('disabled')) {
						$btnsUp.removeClass('disabled');
					}
				}

				$input.trigger('change');
			});

			// on load, check the max and min is not reached
			if (parseInt(oldValue) === minInput && !This.removeZero) {
				$btnsDown.addClass('disabled');
			}
			if (parseInt(oldValue) === 1 && This.removeZero) {
				$btnsDown.addClass('zero');
			}
			if (parseInt(oldValue) === maxInput) {
				$btnsUp.addClass('disabled');
			}
		}

		// Add more functions like on above here

	}]);

	return QuantityInput;
}();

var updateQuantity = exports.updateQuantity = function updateQuantity($element, _ref) {
	var remove = _ref.remove,
	    quantity = _ref.quantity;

	if (quantity) {
		$element.find('input').val(quantity);
	}
	var value = $element.find('input').val();
	if (remove) {
		$element.attr('remove-zero', true);
		if (value == 1) {
			$element.find('.btn-down').removeClass('disabled').addClass('zero');
		}
	} else {
		$element.removeAttr('remove-zero');
		if (value == 1) {
			$element.find('.btn-down').removeClass('zero').addClass('disabled');
		} else {
			$element.find('.btn-down').removeClass('disabled');
		}
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.wg-quantity-input-chunk.js